export default "﻿<div>\n    Meine Dienste\n    <div data-dojo-attach-point=\"tableContainer\">${translations.General__NoEntries}</div>\n\n</div>\n"